<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 lg12>
        <v-card>
          <v-card-title class="align-baseline">
            <h1>Notifications</h1>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="global"
            :total-items="globalCount"
            item-key="_id"
            :pagination.sync="pagination"
            :rows-per-page-items="[100, 200]"
          >
            <template v-slot:items="props">
              <td>
                <span>{{ new Date(props.item.ts).toLocaleString() }}</span>
              </td>
              <td>
                <v-icon class="pr-2">{{ getIcon(props.item) }}</v-icon>
                <template v-if="props.item.kind === 'ProposalCommentTrace'">
                  {{ getFullName(props.item.user) }} a laissé
                  <a
                    :href="`/project/${props.item.projectId}/proposals/${props.item.idSell}`"
                    target="_blank"
                  >
                    un commentaire
                  </a>
                  , n'oublie pas de lui répondre
                </template>
                <template v-else-if="props.item.kind === 'ProjectCommentTrace'">
                  {{ getFullName(props.item.user) }} a laissé
                  <a :href="`/project/${props.item.projectId}`" target="_blank">
                    un commentaire
                  </a>
                  dans la messagerie, n'oublie pas de lui répondre
                </template>
                <template
                  v-else-if="props.item.kind === 'ProjectDocumentTrace'"
                >
                  {{ getFullName(props.item.user) }} a ajouté
                  <a
                    :href="`/project/${props.item.projectId}/documents`"
                    target="_blank"
                  >
                    un document
                  </a>
                  <span v-if="props.item.document && props.item.document.title"
                    >({{ props.item.document.title }})
                  </span>
                </template>
                <template v-else-if="props.item.kind === 'ProposalEvaluation'">
                  {{ getFullName(props.item.user) }} a évalué
                  <a
                    :href="`/project/${props.item.projectId}/proposals/${props.item.idSell}`"
                    target="_blank"
                  >
                    un bien
                  </a>
                  que tu lui as proposé
                </template>
                <template v-else-if="props.item.kind === 'ProposalReport'">
                  {{ getFullName(props.item.user) }} a laissé
                  <a
                    :href="`/project/${props.item.projectId}/proposals/${props.item.idSell}`"
                    target="_blank"
                  >
                    un compte rendu de visite
                  </a>
                  , merci d’en prendre connaissance
                </template>
                <template v-else><span>Évènement inconnu</span></template>
              </td>
              <td>
                <template v-if="props.item.project">
                  {{ getFullName(props.item.project) }}
                </template>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Notifications",
  components: {},
  data() {
    return {
      headers: [
        { text: "Date", value: "ts", sortable: false },
        { text: "Description", value: "desc", sortable: false },
        { text: "Projet", sortable: false },
      ],
      pagination: {},
    };
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.fetch();
      },
    },
  },
  computed: {
    ...mapState("notifications", ["global", "globalCount"]),
  },
  methods: {
    ...mapActions("notifications", ["fetchGlobalNotifications"]),
    fetch() {
      const { page = 1, rowsPerPage = 100 } = this.pagination;
      this.fetchGlobalNotifications({ page: page - 1, pageSize: rowsPerPage });
    },
    getFullName(user) {
      if (!user) {
        return "Un utilisateur";
      }

      return [user.firstName, user.lastName].filter(Boolean).join(" ");
    },
    getIcon(notification) {
      switch (notification.kind) {
        case "ProposalCommentTrace":
        case "ProjectCommentTrace":
          return "comment";
        case "ProjectDocumentTrace":
          return "cloud_upload";
        case "ProposalEvaluation":
          return notification.evaluation > 0 ? "thumb_up" : "thumb_down";
        case "ProposalReport":
          return "assignment_turned_in";
        default:
          return "help";
      }
    },
  },
};
</script>
